import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Skill } from '../models/skill';
import { environment } from '../../environments/environment';
import { PagedResponse } from '../models/paged-response.model';

@Injectable({
  providedIn: 'root',
})
export class SkillsService {
  baseUrl: string = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}


  /**
   * Fetches a paginated list of skills from the API.
   * @param page The requested page number (default 1).
   * @param perPage The number of items per page (default 10).
   * @returns An Observable of the PagedResponse containing skill items and metadata.
   */
  getSkills(page: number = 1, perPage: number = 10): Observable<PagedResponse<Skill>> { 
    let params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());
    
    // Specifies the return type is PagedResponse<any>
    return this.httpClient.get<PagedResponse<Skill>>(`${this.baseUrl}/skills`, { params });
  }

  
  getSkill(skillId: number): Observable<Skill[]> {
    return this.httpClient.get<Skill[]>(
      `${this.baseUrl}/skills/`+ skillId
    );
  }

  delete_skill(id: number): Observable<void> {
    return this.httpClient.delete<void>(
      this.baseUrl + '/skills/' + id
    );
  }

  addSkill(skill : Skill): Observable<Skill> {
    return this.httpClient.post<Skill>(
      this.baseUrl + '/skills',
      skill
    );
  }

  updateSkill(skill : Skill): Observable<Skill> {
    return this.httpClient.put<Skill>(
      this.baseUrl + '/skills/' + skill.id,
      skill
    );
  }
}
